import type { Permission } from '@/core/store/auth/auth.types';

import type { CommonFieldDef, PicklistSource } from './types';

export type AvailabilityContext = {
	countryId: string | null | undefined;
	unavailable: ReadonlySet<string>;
	hasPermission: (permission: Permission) => boolean;
	hasOptions: (source: PicklistSource) => boolean;
};

export const isFieldAllowed = (
	id: string,
	def: CommonFieldDef,
	ctx: AvailabilityContext
): boolean => {
	if (ctx.unavailable.has(id)) return false;

	if (
		def.countries &&
		!(ctx.countryId && def.countries.includes(ctx.countryId))
	) {
		return false;
	}

	if (def.permission && !ctx.hasPermission(def.permission)) return false;

	const countryPermission = ctx.countryId
		? def.permissionByCountry?.[ctx.countryId]
		: undefined;
	if (countryPermission && !ctx.hasPermission(countryPermission)) return false;

	if (def.hideWhenNoOptions && def.picklist && !ctx.hasOptions(def.picklist)) {
		return false;
	}

	return true;
};

export const isFieldAvailable = (
	id: string,
	def: CommonFieldDef,
	ctx: AvailabilityContext
): boolean => def.visibility !== 'off' && isFieldAllowed(id, def, ctx);
